import { supabase } from '../../providers/supabase/client';

/**
 * Procesa una imagen de itinerario de crucero mediante Supabase Edge Function con OpenAI Vision.
 * @param {string} fileBase64 - Imagen en formato base64 o data URL.
 * @param {string} [startDate] - Fecha de inicio opcional (YYYY-MM-DD) para correlacionar días.
 * @returns {Promise<{success: boolean, data?: object, error?: string}>}
 */
export const processCruiseItinerary = async (fileBase64, startDate = null) => {
  const { data, error } = await supabase.functions.invoke('process-cruise-itinerary', {
    body: { fileBase64, startDate },
  });
  if (error) throw error;
  return data;
};
